<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2021-03-31 09:47:30
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-08-18 16:45:48
-->
<template>
  <div class="root">
    <div>
      <span>项目名称：</span>
      <p>{{ detail.projectname }}</p>
    </div>
    <div>
      <span>交易形式：</span>
      <p>{{ detail.type == 1 ? '转出' : '受让' }}</p>
    </div>
    <div>
      <span>区 域：</span>
      <p>{{ detail.areaName }}</p>
    </div>
    <div>
      <span>{{ detail.type == 1 ? '转出' : '承包' }}年限：</span>
      <p>{{ detail.outyears }}</p>
    </div>
    <div>
      <span>面积/数量：</span>
      <p>{{ detail.area }}</p>
    </div>
    <div>
      <span>{{ detail.type == 1 ? '转出' : '接受' }}价格：</span>
      <p>{{ detail.listingprice }}</p>
    </div>
    <div>
      <span>联 系 人：</span>
      <p>{{ detail.linkman }}</p>
    </div>

    <div :title="detail.remark">
      <span>项目简况：</span>
      <p>{{ detail.remark }}</p>
    </div>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    // let id = this.$route.query.id;
    // let url = 'yixiangzhuanchuxiangqing';
    // console.log(this.ajax_id(url,id).data);
    // this.detail = this.ajax_id(url, id).data;
    request({
      url: '/api/desiredDetail',
      method: 'post',
      data: {
        id: this.$route.query.id
      }
    }).then(res => {
      console.log('转出意向详情', res)
      this.detail = res.data.data
    })
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.root {
  /* min-height: 1180px; */
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 40px 100px 60px 285px;
  width: 1475px;
  min-height: 716px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);

}

.root div {
  width: 1300px;
  /* height: 26px; */
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #333333;
  letter-spacing: 2px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid rgb(210, 210, 210);
  margin-bottom: 20px;
}

.root div span {
  /* display:  block; */
  width: 140px;
  height: 26px;
  white-space: nowrap;
  /* padding-right: 10px; */
  color: #151515;
  text-align-last: justify;
  text-justify: distribute-all-lines;
  /* 这行bai必加，兼容ie浏览器 */
  background-color: #f3f5f8;
  display: inline-block;
  align-items: center;
  text-align: center;
  line-height: 26px;
  padding: 24px;
  font-weight: 600;
}

.root div p {
  /* display:  block; */
  width: 1100px;
  height: auto;
  padding: 21px;
}
</style>